import * as DTO from './DTOs';
import * as API from './apisvc';
import * as TF from '../service/tradeflow';
import * as Session from './Session';


export interface UIElementState {
    processing: boolean;
    modified: boolean;
    haserrors: boolean;
    error?: string;
    selected: boolean;

    actions: ElementAction[];
}

export interface ElementAction {
    tag?: string;
    glyph?: string;
    docallback: (manipulation: DTO.ManipulationAction<string>) => void;
    onsuccess?: any;
    onerror?: any;
}




export interface OrderState {
    processing: boolean;
    modified: boolean;
    haserrors: boolean;
    error?: string;
    selected: boolean;
}


interface OrderStartProcessingAction { type: 'ORDER_START_MODIFICATION' }
interface OrderModificationSuccessAction { type: 'ORDER_MODIFICATION_SUCCESS', payload: { manipulation: DTO.ManipulationAction<string> } | undefined }
interface OrderModificationFailedAction { type: 'ORDER_MODIFICATION_FAILED', payload: { error: string | string[] } }
//interface OrderTakeSuccessAction { type: 'ORDER_TAKE_SUCCESS', payload: { order: DTO.RecordOrder } | undefined }
//interface OrderTakeFailedAction { type: 'ORDER_TAKE_FAILED', payload: { error: string | string[] } }

export type OrderAction = | OrderStartProcessingAction | OrderModificationSuccessAction | OrderModificationFailedAction;

export const orderStateForwarder = (state: OrderState, action: OrderAction) => {
    switch (action.type) {
        case 'ORDER_START_MODIFICATION':
            return { processing: true, modified: false, haserrors: false };
        case 'ORDER_MODIFICATION_SUCCESS':
            console.log('ORDER_MODIFICATION_SUCCESS');
            return { processing: false, modified: true, haserrors: false };
        case 'ORDER_MODIFICATION_FAILED':
            console.log('ORDER_MODIFICATION_FAILED');
            return { processing: false, modified: true, haserrors: true };
        default:
            const exhaustiveCheck: never = action;
    }

    return state || { loggedin: false };
};

export const orderActions = {
    modify: (manipulation: DTO.ManipulationAction<string>, getState: () => { xsrfToken: string | undefined }, dispatch: (action: OrderAction) => {}) => {

        return (async () => {
            dispatch({ type: 'ORDER_START_MODIFICATION' });
            //console.log('manipulation = ');
            //console.log(JSON.stringify(manipulation));
            try {
                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
                const response: Response = await fetch(API.apiUrl(API.API_ORDER_MODIFY_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrf || ''
                        },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(manipulation)
                });

                const statusCode = response.status;
                console.log('statusCode = ' + statusCode);

                if (response.ok) {
                    const resp_data = await response.json();
                    const data = resp_data as DTO.MessageDto<DTO.ManipulationAction<string>>;
                    //dispatch(XsrfActionCreators.refresh());
                    // Get updated menu; we may get extra options based on our role
                    // dispatch(NavMenuActionCreators.fetchMenu());
                    // will redirect

                    if (data && data.result) {
                        //TF.PublishCommand('COMMAND.changeuser', data.result);
                        dispatch({ type: 'ORDER_MODIFICATION_SUCCESS', payload: { manipulation: data.result } });
                    }
                    else {
                        dispatch({ type: 'ORDER_MODIFICATION_FAILED', payload: { error: "Ошибка обновления. Нет данных" } });
                    }

                    //history.pushState({}, '', loginInput.returnUrl || '/');
                    //dispatch(push(loginInput.returnUrl || '/'));
                } else {
                    let _error: string | any[] | undefined;
                    const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<string>>;
                    _error = data.validation;
                    console.log(_error);

                    dispatch({ type: 'ORDER_MODIFICATION_FAILED', payload: { error: _error || "Ошибка обработки" } });
                }
            }
            catch (e) {
                dispatch({ type: 'ORDER_MODIFICATION_FAILED', payload: { error: e.message || "Ошибка обработки" } });
            }
        })();
    }
};

interface ContragentLimitsStartProcessingAction { type: 'CONTRAGENTLIMITS_START_MODIFICATION' }
interface ContragentLimitsResetFormAction { type: 'RESET_CONTRAGENTLIMITS_MODIFICATION_FORM' }
interface ContragentLimitsModificationSuccessAction { type: 'CONTRAGENTLIMITS_MODIFICATION_SUCCESS', payload: { manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> } | undefined }
interface ContragentLimitsModificationFailedAction { type: 'CONTRAGENTLIMITS_MODIFICATION_FAILED', payload: { error: string | string[] } }


export type ContragentLimitsAction = | ContragentLimitsStartProcessingAction | ContragentLimitsModificationSuccessAction | ContragentLimitsModificationFailedAction | ContragentLimitsResetFormAction;



export const ContragentLimitsStateForwarder = (state: OrderState, action: ContragentLimitsAction) => {
    switch (action.type) {
        case 'CONTRAGENTLIMITS_START_MODIFICATION':
            return { processing: true, modified: false, haserrors: false, result: undefined, error: undefined };
        case 'CONTRAGENTLIMITS_MODIFICATION_SUCCESS':
            return { processing: false, modified: true, haserrors: false, result: 'OK', error: undefined };
        case 'CONTRAGENTLIMITS_MODIFICATION_FAILED': {
            //console.log('action');
            console.log(action);

            return { processing: false, modified: true, haserrors: true, result: 'FAIL', error: Array.isArray(action.payload.error) ? action.payload.error[0] : action.payload.error };
        }
        case 'RESET_CONTRAGENTLIMITS_MODIFICATION_FORM':
            return { processing: false, modified: true, haserrors: false, result: undefined, error: undefined };
        default:
            const exhaustiveCheck: never = action;
    }

    return state || { loggedin: false };
};

interface FilterSettingsStartProcessingAction { type: 'FILTERSETTINGS_START_MODIFICATION' }
interface FilterSettingsResetFormAction { type: 'RESET_FILTERSETTINGS_MODIFICATION_FORM' }

interface FilterSettingsModificationSuccessAction { type: 'FILTERSETTINGS_MODIFICATION_SUCCESS', payload: { manipulation: DTO.ManipulationAction<string> } | undefined }
interface FilterSettingsModificationFailedAction { type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: string | string[] } }

export type FilterSettingsAction = | FilterSettingsStartProcessingAction | FilterSettingsModificationSuccessAction | FilterSettingsModificationFailedAction | FilterSettingsResetFormAction;


export const filterSettingsStateForwarder = (state: OrderState, action: FilterSettingsAction) => {
    switch (action.type) {
        case 'FILTERSETTINGS_START_MODIFICATION':
            return { processing: true, modified: false, haserrors: false, result: undefined, error: undefined };
        case 'FILTERSETTINGS_MODIFICATION_SUCCESS':
            return { processing: false, modified: true, haserrors: false, result: 'OK', error: undefined };
        case 'FILTERSETTINGS_MODIFICATION_FAILED': {
            //console.log('action');
            //console.log(action);

            return { processing: false, modified: true, haserrors: true, result: 'FAIL', error: Array.isArray(action.payload.error) ? action.payload.error[0] : action.payload.error };
        }
        case 'RESET_FILTERSETTINGS_MODIFICATION_FORM':
            return { processing: false, modified: true, haserrors: false, result: undefined, error: undefined };
        default:
            const exhaustiveCheck: never = action;
    }

    return state || { loggedin: false };
};


export const caLimitActions = {
    modifypick: (manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin>, getState: () => { xsrfToken: string | undefined }, dispatch: (action: ContragentLimitsAction) => {}) => {

        return (async () => {
            dispatch({ type: 'CONTRAGENTLIMITS_START_MODIFICATION' });
            try {
                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
                const response: Response = await fetch(API.apiUrl(API.API_CALIMITS_MODIFY_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrf || ''
                        },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(manipulation)
                });

                const statusCode = response.status;
                //console.log('modifypick statusCode = ' + statusCode);

                if (response.ok) {
                    const resp_data = await response.json();
                    const data = resp_data as DTO.MessageDto<DTO.ManipulationAction<DTO.NotesContragentMargin>>;

                    if (data && data.result) {
                        dispatch({ type: 'CONTRAGENTLIMITS_MODIFICATION_SUCCESS', payload: { manipulation: data.result } });

                        setTimeout(() => {
                            dispatch({ type: 'RESET_CONTRAGENTLIMITS_MODIFICATION_FORM' });
                        }, 2000);
                    }
                    else {
                        dispatch({ type: 'CONTRAGENTLIMITS_MODIFICATION_FAILED', payload: { error: "Ошибка обновления. Нет данных" } });
                    }
                }
                else if (statusCode === 422) {

                    let err = await response.json() as { manipulationActionDto: string[] };

                    dispatch({ type: 'CONTRAGENTLIMITS_MODIFICATION_FAILED', payload: { error: err.manipulationActionDto || "Ошибка обработки" } });
                }
                else {
                    let _error: string | any[] | undefined;
                    const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<DTO.NotesContragentMargin>>;
                    //console.log(data);
                    _error = data.validation;
                    console.log(_error);

                    dispatch({ type: 'CONTRAGENTLIMITS_MODIFICATION_FAILED', payload: { error: _error || "Ошибка обработки" } });
                }
            }
            catch (e) {
                dispatch({ type: 'CONTRAGENTLIMITS_MODIFICATION_FAILED', payload: { error: e.message || "Ошибка обработки" } });
            }
        })();
    }
};


export const secFilterActions = {
    modify: (manipulation: DTO.ManipulationAction<string>, getState: () => { xsrfToken: string | undefined }, dispatch: (action: FilterSettingsAction) => {}) => {

        return (async () => {
            dispatch({ type: 'FILTERSETTINGS_START_MODIFICATION' });
            try {
                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
                const response: Response = await fetch(API.apiUrl(API.API_SECFILTER_MODIFY_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrf || ''
                        },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(manipulation)
                });

                const statusCode = response.status;
                //console.log('statusCode = ' + statusCode);

                if (response.ok) {
                    const resp_data = await response.json();
                    const data = resp_data as DTO.MessageDto<DTO.ManipulationAction<string>>;

                    if (data && data.result) {
                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_SUCCESS', payload: { manipulation: data.result } });

                        setTimeout(() => {
                            dispatch({ type: 'RESET_FILTERSETTINGS_MODIFICATION_FORM' });
                        }, 2000);
                    }
                    else {
                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: "Ошибка обновления. Нет данных" } });
                    }
                }
                else if (statusCode === 422) {
                    let err = await response.json() as { manipulationActionDto: string[] };

                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: err.manipulationActionDto || "Ошибка обработки" } });
                }
                else {
                    let _error: string | any[] | undefined;
                    const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<string>>;
                    _error = data.validation;
                    console.log(_error);

                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: _error || "Ошибка обработки" } });
                }
            }
            catch (e) {
                dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: e.message || "Ошибка обработки" } });
            }
        })();
    }
};


export const caFilterActions = {
    modify: (manipulation: DTO.ManipulationAction<string>, getState: () => { xsrfToken: string | undefined }, dispatch: (action: FilterSettingsAction) => {}) => {

        return (async () => {
            dispatch({ type: 'FILTERSETTINGS_START_MODIFICATION' });
            try {
                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
                const response: Response = await fetch(API.apiUrl(API.API_CAFILTER_MODIFY_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrf || ''
                        },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(manipulation)
                });

                const statusCode = response.status;
                //console.log('statusCode = ' + statusCode);

                if (response.ok) {
                    const resp_data = await response.json();
                    const data = resp_data as DTO.MessageDto<DTO.ManipulationAction<string>>;

                    if (data && data.result) {
                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_SUCCESS', payload: { manipulation: data.result } });

                        setTimeout(() => {
                            dispatch({ type: 'RESET_FILTERSETTINGS_MODIFICATION_FORM' });
                        }, 2000);
                    }
                    else {
                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: "Ошибка обновления. Нет данных" } });
                    }
                }
                else if (statusCode === 422) {
                    let err = await response.json() as { manipulationActionDto: string[] };

                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: err.manipulationActionDto || "Ошибка обработки" } });
                }
                else {
                    let _error: string | any[] | undefined;
                    const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<string>>;
                    _error = data.validation;
                    console.log(_error);

                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: _error || "Ошибка обработки" } });
                }
            }
            catch (e) {
                dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: e.message || "Ошибка обработки" } });
            }
        })();
    }
};



export const chatActions = {
    getOrCreateChat: (owner: Session.UserState, trader: Session.PersonalState) => {
        return (async () => {

            //console.log('getOrCreateChat');
            //console.log(this.state.user);

            if (!owner.identityState)
                return { chat: undefined };

            try {
                const xsrf = '';

                const response: Response = await fetch(API.apiUrl(API.API_GETORCREATE_PRIVATECHAT_URL) + '/' + owner.identityState.userName + '/' + trader.idperson, {
                    method: 'GET',
                    credentials: 'include',
                    headers: new Headers({
                        ...{ 'X-XSRF-TOKEN': xsrf || '' },
                        ...API.authHeader()
                    })
                });


                if (response.ok) {
                    const resp_data = await response.json();

                    const data = resp_data as DTO.AgentChat;

                    if (data) {
                        return { chat: data };
                    }
                    else {
                    }

                    return { chat: undefined };
                }
                else {
                    return { chat: undefined };
                }

            } catch (error) {
                return { chat: undefined };
            }
        })();
    }
}

















//import * as DTO from './DTOs';
//import * as API from './apisvc';
//import * as TF from '../service/tradeflow';


//export interface UIElementState {
//    processing: boolean;
//    modified: boolean;
//    haserrors: boolean;
//    error?: string;
//    selected: boolean;

//    actions: ElementAction[];
//}

//export interface ElementAction {
//    tag?: string;
//    glyph?: string;
//    docallback: (manipulation: DTO.ManipulationAction<string>) => void;
//    onsuccess?: any;
//    onerror?: any;
//}




//export interface OrderState {
//    processing: boolean;
//    modified: boolean;
//    haserrors: boolean;
//    error?: string;
//    selected: boolean;
//}


//interface OrderStartProcessingAction { type: 'ORDER_START_MODIFICATION' }
//interface OrderModificationSuccessAction { type: 'ORDER_MODIFICATION_SUCCESS', payload: { manipulation: DTO.ManipulationAction<string> } | undefined }
//interface OrderModificationFailedAction { type: 'ORDER_MODIFICATION_FAILED', payload: { error: string | string[] } }
////interface OrderTakeSuccessAction { type: 'ORDER_TAKE_SUCCESS', payload: { order: DTO.RecordOrder } | undefined }
////interface OrderTakeFailedAction { type: 'ORDER_TAKE_FAILED', payload: { error: string | string[] } }

//export type OrderAction = | OrderStartProcessingAction | OrderModificationSuccessAction | OrderModificationFailedAction;

//export const orderStateForwarder = (state: OrderState, action: OrderAction) => {
//    switch (action.type) {
//        case 'ORDER_START_MODIFICATION':
//            return { processing: true, modified: false, haserrors: false};
//        case 'ORDER_MODIFICATION_SUCCESS':
//            console.log('ORDER_MODIFICATION_SUCCESS');
//            return { processing: false, modified: true, haserrors: false };
//        case 'ORDER_MODIFICATION_FAILED':
//            console.log('ORDER_MODIFICATION_FAILED');
//            return { processing: false, modified: true, haserrors: true};
//        default:
//            const exhaustiveCheck: never = action;
//    }

//    return state || { loggedin: false };
//};

//export const orderActions = {
//    modify: (manipulation: DTO.ManipulationAction<string>, getState: () => { xsrfToken: string | undefined}, dispatch: (action: OrderAction) => {}) => {

//        return (async () => {
//            dispatch({ type: 'ORDER_START_MODIFICATION' });
//            //console.log('manipulation = ');
//            //console.log(JSON.stringify(manipulation));
//            try {
//                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
//                const response: Response = await fetch(API.apiUrl(API.API_ORDER_MODIFY_URL), {
//                    method: 'POST',
//                    credentials: 'include',
//                    headers: new Headers({
//                        ...
//                        {
//                            'Content-Type': 'application/json',
//                            'X-XSRF-TOKEN': xsrf || ''
//                        },
//                        ...API.authHeader()
//                    }),
//                    body: JSON.stringify(manipulation)
//                });

//                const statusCode = response.status;
//                console.log('statusCode = ' + statusCode);

//                if (response.ok) {
//                    const resp_data = await response.json();
//                    const data = resp_data as DTO.MessageDto<DTO.ManipulationAction<string>>;
//                    //dispatch(XsrfActionCreators.refresh());
//                    // Get updated menu; we may get extra options based on our role
//                    // dispatch(NavMenuActionCreators.fetchMenu());
//                    // will redirect

//                    if (data && data.result) {
//                         //TF.PublishCommand('COMMAND.changeuser', data.result);
//                         dispatch({ type: 'ORDER_MODIFICATION_SUCCESS', payload: { manipulation: data.result } });
//                    }
//                    else {
//                        dispatch({ type: 'ORDER_MODIFICATION_FAILED', payload: { error: "Ошибка обновления. Нет данных" } });
//                    }
                    
//                    //history.pushState({}, '', loginInput.returnUrl || '/');
//                    //dispatch(push(loginInput.returnUrl || '/'));
//                } else {
//                    let _error: string | any[] | undefined;
//                    const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<string>>;
//                    _error = data.validation;
//                    console.log(_error);
                    
//                    dispatch({ type: 'ORDER_MODIFICATION_FAILED', payload: { error: _error || "Ошибка обработки"} });
//                }
//            }
//            catch (e) {
//                dispatch({ type: 'ORDER_MODIFICATION_FAILED', payload: { error: e.message || "Ошибка обработки" } });
//            }
//        })();
//    }
//};


//interface FilterSettingsStartProcessingAction { type: 'FILTERSETTINGS_START_MODIFICATION' }
//interface FilterSettingsResetFormAction { type: 'RESET_FILTERSETTINGS_MODIFICATION_FORM' }

//interface FilterSettingsModificationSuccessAction { type: 'FILTERSETTINGS_MODIFICATION_SUCCESS', payload: { manipulation: DTO.ManipulationAction<string> } | undefined }
//interface FilterSettingsModificationFailedAction { type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: string | string[] } }

//export type FilterSettingsAction = | FilterSettingsStartProcessingAction | FilterSettingsModificationSuccessAction | FilterSettingsModificationFailedAction | FilterSettingsResetFormAction;

//export const filterSettingsStateForwarder = (state: OrderState, action: FilterSettingsAction) => {
//    switch (action.type) {
//        case 'FILTERSETTINGS_START_MODIFICATION':
//            return { processing: true, modified: false, haserrors: false, result: undefined , error: undefined };
//        case 'FILTERSETTINGS_MODIFICATION_SUCCESS':
//            return { processing: false, modified: true, haserrors: false, result: 'OK', error: undefined };
//        case 'FILTERSETTINGS_MODIFICATION_FAILED': {
//            //console.log('action');
//            //console.log(action);

//            return { processing: false, modified: true, haserrors: true, result: 'FAIL', error: Array.isArray(action.payload.error) ? action.payload.error[0]: action.payload.error };
//        }
//        case 'RESET_FILTERSETTINGS_MODIFICATION_FORM':
//            return { processing: false, modified: true, haserrors: false, result: undefined, error: undefined  };
//        default:
//            const exhaustiveCheck: never = action;
//    }

//    return state || { loggedin: false };
//};

//export const secFilterActions = {
//    modify: (manipulation: DTO.ManipulationAction<string>, getState: () => { xsrfToken: string | undefined }, dispatch: (action: FilterSettingsAction) => {}) => {

//        return (async () => {
//            dispatch({ type: 'FILTERSETTINGS_START_MODIFICATION' });
//            try {
//                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
//                const response: Response = await fetch(API.apiUrl(API.API_SECFILTER_MODIFY_URL), {
//                    method: 'POST',
//                    credentials: 'include',
//                    headers: new Headers({
//                        ...
//                        {
//                            'Content-Type': 'application/json',
//                            'X-XSRF-TOKEN': xsrf || ''
//                        },
//                        ...API.authHeader()
//                    }),
//                    body: JSON.stringify(manipulation)
//                });

//                const statusCode = response.status;
//                //console.log('statusCode = ' + statusCode);

//                if (response.ok) {
//                    const resp_data = await response.json();
//                    const data = resp_data as DTO.MessageDto<DTO.ManipulationAction<string>>;

//                    if (data && data.result) {
//                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_SUCCESS', payload: { manipulation: data.result } });

//                        setTimeout(() => {
//                            dispatch({ type: 'RESET_FILTERSETTINGS_MODIFICATION_FORM' });
//                        }, 2000);
//                    }
//                    else {
//                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: "Ошибка обновления. Нет данных" } });
//                    }
//                }
//                else if (statusCode === 422) {
//                    let err = await response.json() as { manipulationActionDto: string[] };
                    
//                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: err.manipulationActionDto || "Ошибка обработки" } });
//                }
//                else {
//                    let _error: string | any[] | undefined;
//                    const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<string>>;
//                    _error = data.validation;
//                    console.log(_error);

//                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: _error || "Ошибка обработки" } });
//                }
//            }
//            catch (e) {
//                dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: e.message || "Ошибка обработки" } });
//            }
//        })();
//    }
//};


//export const caFilterActions = {
//    modify: (manipulation: DTO.ManipulationAction<string>, getState: () => { xsrfToken: string | undefined }, dispatch: (action: FilterSettingsAction) => {}) => {

//        return (async () => {
//            dispatch({ type: 'FILTERSETTINGS_START_MODIFICATION' });
//            try {
//                const xsrf = getState().xsrfToken ? getState().xsrfToken : '';
//                const response: Response = await fetch(API.apiUrl(API.API_CAFILTER_MODIFY_URL), {
//                    method: 'POST',
//                    credentials: 'include',
//                    headers: new Headers({
//                        ...
//                        {
//                            'Content-Type': 'application/json',
//                            'X-XSRF-TOKEN': xsrf || ''
//                        },
//                        ...API.authHeader()
//                    }),
//                    body: JSON.stringify(manipulation)
//                });

//                const statusCode = response.status;
//                //console.log('statusCode = ' + statusCode);

//                if (response.ok) {
//                    const resp_data = await response.json();
//                    const data = resp_data as DTO.MessageDto<DTO.ManipulationAction<string>>;

//                    if (data && data.result) {
//                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_SUCCESS', payload: { manipulation: data.result } });

//                        setTimeout(() => {
//                            dispatch({ type: 'RESET_FILTERSETTINGS_MODIFICATION_FORM' });
//                        }, 2000);
//                    }
//                    else {
//                        dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: "Ошибка обновления. Нет данных" } });
//                    }
//                }
//                else if (statusCode === 422) {
//                    let err = await response.json() as { manipulationActionDto: string[] };

//                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: err.manipulationActionDto || "Ошибка обработки" } });
//                }
//                else {
//                    let _error: string | any[] | undefined;
//                    const data = await response.json() as DTO.ErrorMessageDto<DTO.ManipulationAction<string>>;
//                    _error = data.validation;
//                    console.log(_error);

//                    dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: _error || "Ошибка обработки" } });
//                }
//            }
//            catch (e) {
//                dispatch({ type: 'FILTERSETTINGS_MODIFICATION_FAILED', payload: { error: e.message || "Ошибка обработки" } });
//            }
//        })();
//    }
//};
